import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { /* Link, */ browserHistory } from 'react-router';
// import isEmpty from 'lodash/isEmpty';
import lodashGet from 'lodash/get';
import * as actions from '../../actions';
import * as Constants from '../../constants';
import * as Helper from '../../utils/helper';
import FooterButtons from '../../components/Button/FooterButtons';
import PathlabPkgCard from '../../components/PathlabPkg/PathlabPkgCard';
import PathlabTestCard from '../../components/PathlabTest/PathlabTestCard';

import './AddProducts.scss';

const initialState = {
  searchText: '',
  buttonLoading: -1,
  isInputFocused: false,
  openDrawer: false,
  nonLiveTest: false,
};

class AddDiagnosticsProducts extends Component {

  constructor(props) {
    super(props);
    this.state = initialState;
  }

  componentWillMount() {
    this.props.actions.changeHeaderState(Constants.ADD_PRODUCTS);
    this.setState({ selectedComponentId: 2 });
  }

  searchProduct = event => {
    const searchText = event.target.value;
    this.setState({ searchText });
    this.props.actions.clearDiagSearch();
    Helper.debouncePE(400, () => this.props.actions.searchDiagnosticsProducts(searchText, this.props.selectedLab.item_id).then((res = {}) => {
      if (res.data && res.data.results_count > 10) {
        this.props.actions.searchDiagnosticsProducts(searchText, this.props.selectedLab.item_id, 2);
      }
    }));
  }

  backToCustomerInfo = () => {
    browserHistory.push({ pathname: '/customer-info', state: { alreadyVisitedCustomerInfoPage: true } });
  }

  selectDeliveryAddress = () => {
    if (this.props.testDetails.length > 0) {
      this.props.testDetails.forEach(test => {
        if (!test.is_live) {
          this.setState({
            nonLiveTest: true,
          });
          alert(`${test.item_name} can no longer be booked.`);
        }
        return null;
      });
    }
    if (this.props.testDetails.length > 0 && this.props.selectedLab.is_active && !this.state.nonLiveTest) {
      browserHistory.push('/diagnostics/select-address');
    } else if (this.props.testDetails.length < 1) {
      alert('Cart Empty. Add 1 or more test/package to proceed');
    } else if (!this.props.selectedLab.is_active) {
      alert(`${this.props.selectedLab.item_name} is nolonger servicable. Please select another lab to proceed.`);
    }
  }

  cancelOrder = () => {
    if (confirm('Are you sure you want to cancel this order ?')) {
      this.reset();
      this.props.actions.setLeadCx('');
      this.props.actions.cancelOrder();
      browserHistory.push('/customer-info');
    }
  }
  reset = () => {
    this.setState(initialState);
  }

  resetInputFocus = () => {
    this.setState({
      isInputFocused: false,
    });
    this.nameInput.focus();
  }

  openSlots = () => {
    this.setState({
      openDrawer: true,
    });
  }

  render() {
    const { searchText } = this.state;
    const { selectedLab, searchResults, error } = this.props;
    return (
      <div className="AddProductsContainer">
        <div className="AddProductsHeader">
          <div className="pageTitle">Add Products</div>
        </div>
        <div className="AddProductsSearchContainer">
          <input
            type="text"
            className="CustomerInput"
            value={searchText}
            ref={input => { this.nameInput = input; }}
            placeholder="Search by test/package name"
            onChange={this.searchProduct}
          />
        </div>
        <div className="TabContentContainer">
          {searchResults.length > 0 ? searchResults.map((product, index) => {
            if (product.item_type === 'test') {
              return <PathlabTestCard key={index} product={product} labID={selectedLab.item_id} />;
            } else if (product.item_type === 'package') {
              return <PathlabPkgCard key={index} product={product} labID={selectedLab.item_id} />;
            } else if (product.item_type === 'profile') {
              return <PathlabTestCard key={index} product={product} labID={selectedLab.item_id} />;
            }
            return null;
          }) : <div className="error">{error.message}</div>}
        </div>
        <FooterButtons
          backBtnText="Back to Customer Info"
          backBtnClick={() => this.backToCustomerInfo()}
          proceedBtnClick={() => this.selectDeliveryAddress()}
          proceedBtnText="Sample Pickup Address"
          cancelBtnClick={() => this.cancelOrder()}
          cancelBtnText="Cancel Order" />
      </div>
    );
  }
}

AddDiagnosticsProducts.propTypes = {
  actions: PropTypes.object,
  selectedLab: PropTypes.object,
  error: PropTypes.object,
  testDetails: PropTypes.array,
  searchResults: PropTypes.array,
};


AddDiagnosticsProducts.defaultProps = {
  actions: {},
  selectedLab: {},
  testDetails: [],
  searchResults: [],
  error: {},
};

export default connect(state => ({
  testDetails: state.diagnosticsCart.testDetails,
  selectedLab: state.diagnosticsCart.selectedLab,
  searchResults: state.product.searchResultsDiagnostics,
  error: state.product.error,
}), dispatch => ({
  actions: bindActionCreators(actions, dispatch)
}))(AddDiagnosticsProducts);
